import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { ACCREDITED_ESTABLISHMENTS_PROVIDER } from '@/global/constants/reactQueryKeys'
import {
  GetProviderDetailResponse,
  getProviderDetails
} from '@/modules/accredited-establishments/api'
import { addError } from '@/global/plugins/observability'
import {
  AccreditedEstablishmentsCode,
  Context
} from '@/global/plugins/observability/observability.constants'
import { AxiosError } from 'axios'
import { toastApiError } from '@/global/utils/toastApiError/toastApiError'
import { ApiErrorResponse } from '@/global/api/types'

export interface UseGetProviderDetailProps {
  referencedId?: string
}

export const useGetProviderDetail = ({
  referencedId
}: UseGetProviderDetailProps) => {
  const result = useQuery<
    GetProviderDetailResponse,
    AxiosError<ApiErrorResponse>
  >({
    queryKey: [...ACCREDITED_ESTABLISHMENTS_PROVIDER, referencedId],
    queryFn: () => getProviderDetails(referencedId!),
    enabled: !!referencedId
  })

  const { error } = result

  useEffect(() => {
    if (error) {
      const data = {
        context: Context.ACCREDITED_ESTABLISHMENTS,
        code: AccreditedEstablishmentsCode.GET_PROVIDER_DETAILS_ERROR,
        message: `Erro ao obter dados do provedor de saúde ${referencedId}`
      }
      addError({ error, data })

      toastApiError({ status: error.response?.status })
    }
  }, [error, referencedId])

  return result
}
